import { api } from "./base-config";
import { User } from "model/user.model";
import { UsersMap } from "store/types/tenant-context.types";
import { mapToUserModel, UserDTO } from "api/dto/UserDTO";

/** ---- API CALLS ---- */
export const findUsersByIds = (userIds: number[]): Promise<UsersMap> => {
  const jaxbList = {
    list: userIds
  };

  return api
    .post(`/resources/secured/rs/users/findByIds`, jaxbList)
    .then(response => mapUserList(response.data));
};

/** ---- API MAPPING ---- */
const mapUserList = (users: Array<UserDTO>): UsersMap => {
  const usersMap: { [userId: number]: User } = {};
  if (users) {
    users.forEach((user: UserDTO) => {
      usersMap[user.id] = mapToUserModel(user);
    });
  }
  return usersMap;
};
